import {Map} from "./map.mjs"

export class GoogleMaps extends Map{
    constructor(...params){
        super(...params);
    
    }
    // ==========
    // private 
    // ----------
    setElement(e){ this.element = e }

    getElement(){ return this.element }

    /*  https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerLabel  */
    createLabel(text, color, fontWeight, fontSize){
        return { text, color, fontWeight, fontSize }; 
    }


    createIcon(url, size, factor){
        var width = size[0];
        var height = size[1];
        var size = new google.maps.Size( width , height);
        var scaledSize = new google.maps.Size(width * factor, height * factor)
        var icon = { url };
        icon.origin = new google.maps.Point(0,0);
        // var zoom = this.getMap().getZoom();
        icon.size = size;
        icon.scaledSize = scaledSize;
        return icon;
    }



    




    // ===========
    // overload 
    // -----------
    createMap(element, options ){ 
        this.setElement(element);
        return new google.maps.Map(element, options)
     }

    /* https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerOptions  */
    createMarker(url, size, factor, labelText, position = [], data){
        var markerOptions = {};
        markerOptions.position = new google.maps.LatLng(...position);
        var labelColor = 'black';
        var labelFontWeight = 'bold';
        var labelFontSize = '12px';
        markerOptions.label = null;
        markerOptions.title = labelText;
        markerOptions.icon = this.createIcon(url, size, factor);
        var marker = new google.maps.Marker(markerOptions);
        marker.labelBackup = this.createLabel(labelText, labelColor, labelFontWeight, labelFontSize);  
        marker.getData = ()=>data;
        return marker;
    }

    /*
    updateMarkerIconSize(marker){
        var zoom = this.getMap().getZoom();
        var icon = marker.getIcon();
        this.updateIconSize(icon, zoom);
    }
    */

    updateMarkerIconSize(marker, factor){
        var icon = marker.getIcon();
        var { height, width } = icon.scaledSize;   
        //icon.size = new google.maps.Size(width , height  )
        icon.scaledSize = new google.maps.Size(width * factor , height * factor )//new google.maps.Size(37,52)   // client needs to provide this info
        marker.setIcon(icon);
    }

    updateMarkerDisplayLabel(marker){
        var zoom = this.getMap().getZoom();
       // console.log(marker.labelBackup)
        if (zoom < 13) marker.setLabel(null);  // should be configurable 
        else marker.setLabel(marker.labelBackup)
    }

    removeFromMap(marker){
        marker.setMap(null);    
    }


    addToMap(layer){
        var map = this.getMap();
        layer.setMap(map);
    }

    addMarkerEventListener(event,handler){
        return (marker)=>{
            var eventHandler = ()=>{ handler.call(this,marker)}
            google.maps.event.addListener(marker,event,eventHandler);
        }
    }

    fitBounds(bounds){
        var map = this.getMap();
        /*
        var ne = new google.maps.LatLng(bounds.north, bounds.east);
        var sw = new google.maps.LatLng(bounds.south,bounds.west);
        var googleBounds = new google.maps.LatLngBounds(sw, ne);
        */
        var testBounds = map.getBounds();
        var ne = testBounds.getNorthEast();
        var sw = testBounds.getSouthWest();
        console.log('ne lat', ne.lat(), 'ne lon', ne.lng())
        console.log('sw lat', sw.lat(), 'sw lon', sw.lng())


        map.fitBounds(bounds);
        console.log(bounds);
        testBounds = map.getBounds();
        var ne = testBounds.getNorthEast();
        var sw = testBounds.getSouthWest();
        console.log('ne lat', ne.lat(), 'ne lon', ne.lng())
        console.log('sw lat', sw.lat(), 'sw lon', sw.lng())
    }

    /* added 13-05-2021 */
    onMarkerClick(marker){
        var data = marker.getData();
        var event = new CustomEvent('clickEvent', { 'detail': { data }  , bubbles: true });  // https://developer.mozilla.org/fr/docs/Web/API/Event/Event
        this.getElement().dispatchEvent(event);
    }
}